import React, {useEffect, useRef, useState} from 'react';
import {Button, Modal, Spin} from "antd";
import CodeEditor from "../../../components/CodeEditor/CodeEditor";

interface EditFileProps {
    selectedFile: SelectedFileSchema;
    handleModalClose: () => void;
    handleModalOK: (key: string, newContent: string) => void;
    isModalOpen: boolean;
    loading?: boolean;
}

export interface SelectedFileSchema {
    filename: string;
    extension: string;
    path: string;
    content: string;
}

function EditFileModal({ selectedFile, handleModalClose, isModalOpen, loading, handleModalOK }: EditFileProps) {
    const [fileContent, setFileContent] = useState(selectedFile.content);
    const fileContentRef = useRef(fileContent);
    const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform);

    useEffect(() => {
        fileContentRef.current = fileContent;
    }, [fileContent]);

    useEffect(() => {
        if (!isModalOpen) {
            return;
        }

        const onKeyDown = (event: KeyboardEvent) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
                event.preventDefault();
                event.stopPropagation();

                if (!loading) {
                    handleModalOK(selectedFile.path, fileContentRef.current);
                }
            }
        };

        window.addEventListener('keydown', onKeyDown, true);
        return () => window.removeEventListener('keydown', onKeyDown, true);
    }, [isModalOpen, loading, selectedFile.path, handleModalOK]);

    return (
        <Modal
            className="file-editor-modal"
            width={'90%'}
            title={
                <div className="file-editor-modal-title">
                    <span className="file-editor-modal-title-label">Documento</span>
                    <span className="file-editor-modal-title-name">{selectedFile.filename}</span>
                </div>
            }
            open={isModalOpen}
            onCancel={handleModalClose}
            maskClosable={false}
            destroyOnClose
            footer={
                <div className="file-editor-modal-footer">
                    <span className="file-editor-modal-hint">
                        <kbd>{isMac ? '⌘' : 'Ctrl'}</kbd> + <kbd>S</kbd> para guardar
                    </span>
                    <div className="file-editor-modal-actions">
                        <Button onClick={handleModalClose} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            type="primary"
                            loading={loading}
                            onClick={() => handleModalOK(selectedFile.path, fileContent)}
                        >
                            Guardar
                        </Button>
                    </div>
                </div>
            }
        >
            <Spin spinning={loading}>
                <CodeEditor
                    extension={selectedFile.extension}
                    fileContent={selectedFile.content}
                    setFileContent={setFileContent}
                    compact
                />
            </Spin>
        </Modal>
    );
}

export default EditFileModal;
